export const SELECT_VARIANTS = {
  DEFAULT: 'default',
  GHOST: 'ghost',
}

export const SELECT_POPOVER_PROPS = {
  BOTTOM_RIGHT: { anchorOrigin: { vertical: 'bottom', horizontal: 'right' } },
  BOTTOM_CENTER: { anchorOrigin: { vertical: 'bottom', horizontal: 'center' } },
}
